import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MyBusinessApiService } from '@app/modules/my-business/services/my-business.api.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'sbnb-edit-business',
  templateUrl: './edit-business.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditBusinessComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly myBusinessApiService = inject(MyBusinessApiService);

  public business$ = this.route.params.pipe(
    switchMap((params) => this.myBusinessApiService.getBusiness(params['uuid']))
  );

  public onSave() {
    this.router.navigate(['/operations/my-business/businesses']);
  }
}
